export class SiteWrapper extends HTMLElement {
    constructor() {
        super();
    }
    
    connectedCallback() {
        this.init();
    }

    init() {
        this.initEventHandlers();
    }
 
    initEventHandlers() {
        // Initialize event handlers here
    }   

}

customElements.define('site-wrapper', SiteWrapper);